<template>
  <div class="containter">
    <navTop class="navTop navFixed" :topFixed="true" :topIndex="topIndex" />
    <div class="banner-box">
      <img :src="bg" alt="">
      <div class="title">
        <p>我们专注于领先的SaaS平台服务</p>
        <p>您的信赖，是我们最大的动力</p>
      </div>
    </div>
    <div class="about">
      <div class="title">公司简介</div>
      <div class="about-box">
        <img :src="i1" alt="" class="i1">
        <div class="content">
          <p class="company"><span style="color:rgba(51,51,51,1);">Company Profile</span><span>/公司简介</span></p>
          <p class="line"></p>
          <p class="txt"><span style="color:#333333;font-weight:bold;">前海智绘</span> 是国内成立最早的游乐产业数字化运营服务平台，是国内首家能为游乐产业提供完整的“游乐场所+互联网“整体解决方案的独立第三方服务机构，其目标是将移动互联和大数据的新技术手段和成功场所的运营理念相结合，帮助游乐企业在成本可控的前提下，实现场所移动化和数字运营转型，增强消费者满意度，提升场所经营效率。</p>
          <p class="txt"><span style="color:#333333;font-weight:bold;">十年沉淀 厚积薄发，</span>核心团队大多来自于阿里巴巴、金蝶、华为、富士康等知名互联网企业，并且有多年互联网产品以及大型项目的丰富工作经验，产品研发及技术实力雄厚，团队自研产品经过十年技术打磨和多行业市场验证。自前海智绘创立以来，始终聚焦物联网平台+行业PaaS/SaaS应用拓展，得到了广大投资者和客户的青睐，万物互联，数据为王，感谢这个伟大的时代，让我们一道为梦前行！</p>
        </div>
      </div>
    </div>
    <div class="address">
      <div class="title">联系我们</div>
      <div class="about-box">
        <div class="map">
          <baidu-map class="map" :center="map.center" :zoom="map.zoom" @ready="handler">
            <bm-marker :position="map.center" :dragging="map.dragging" animation="BMAP_ANIMATION_DROP">
            </bm-marker>
        </baidu-map>
        </div>
        <ul class="content">
          <li><p class="label">公司名称:</p><p>深圳前海智绘大数据服务有限公司</p></li>
          <li><p class="label">官网地址:</p><a href="http://tenants.intel-yun.com/tenants/login">http://tenants.intel-yun.com/tenants/login</a></li>
          <li><p class="label">联系我们:</p><p>0755-29739988&nbsp;&nbsp;0755-29001122</p></li>
          <li><p class="label">联系地址:</p><p>深圳总部-深圳市宝安区宝源路168号华源科技创新园B座1区229、233室<br/>广州分部-广州市番禺区东环街迎星东路143号星力产业园I13、I15、I16 </p></li>
        </ul>
      </div>
    </div>
    <footer-a />
    <back-top />
  </div>
</template>

<script>
import bg from '../assets/images/about/bg.png'
import i1 from '../assets/images/about/1.png'
import product from '../assets/json/product'
import navTop from '../components/nav'
import footerA from '../components/footer'
import backTop from '../components/backTop'
export default {
  data () {
    return {
      bg: bg,
      product: product,
      topIndex: 4,
      i1: i1,
      map: {
        center: {lng: 113.873058, lat: 22.574632},
        zoom: 18,
        show: true,
        dragging: true
      }
    }
  },
  components: {navTop, footerA, backTop},
  methods: {
    handler ({BMap, map}) {
      // 鼠标缩放
      map.enableScrollWheelZoom(true)
      // 点击事件获取经纬度
      map.addEventListener('click', function (e) {
        console.log(e.point.lng, e.point.lat)
      })
    }
  }
}
</script>

<style scoped>
  .banner-box{
    position: relative;
    width: 100%;
    height: 400px;
  }
  .banner-box>img{
    width: 100%;
    height: 100%;
  }
  .banner-box .title{
    position: absolute;
    top: 50%;
    left: 50%;
    color: #ffffff;
    border: 1px solid rgba(255, 255, 255, .32);
    font-size:30px;
    line-height:53px;
    font-family:PingFang SC;
    transform: translate(-50%, -50%);
    padding: 30px 100px;
  }
  .about{
    padding: 110px 374px 110px 390px;
    background: #ffffff;
  }
  .address .title,
  .about .title{
    font-size:34px;
    font-family:PingFang SC;
    font-weight:bold;
    line-height:60px;
    color:rgba(51,51,51,1);
    opacity:1;
    margin-bottom: 108px;
  }
  .about-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .about .content{
    width: 650px;
    text-align: left;
  }
  .about .company{
    font-size:24px;
    font-family:PingFang SC;
    font-weight:400;
    line-height:42px;
    color:rgba(153,153,153,1);
    margin-bottom: 25px;
  }
  .about .line{
    width:53px;
    height:4px;
    background:rgba(252,189,1,1);
    margin-bottom: 58px;
  }
  .about .txt{
    font-size:14px;
    font-family:PingFang SC;
    font-weight:400;
    line-height:25px;
    color:rgba(102,102,102,1);
    margin-bottom: 20px;
  }
  .about .i1{
    width: 439px;
  }
  .address{
    padding: 110px 350px;
    background:rgba(247,248,248,1);
  }
  .address .content li{
    width: 695px;
    display: flex;
    justify-content: left;
    align-items: stretch;
    text-align: left;
    font-size:24px;
    font-family:PingFang SC;
    font-weight:400;
    line-height:42px;
    color:rgba(102,102,102,1);
  }
  .address .content li .label{
    width: 120px;
    flex-shrink: 0;
    color:rgba(153,153,153,1);
  }
  .map{
    width: 439px;
    height: 329px;
  }
</style>



// WEBPACK FOOTER //
// src/view/about.vue